module.exports = __webpack_public_path__ + "static/media/vehicle.15f10457.svg";